import { Loading } from '@/components/loading/Loading';
import { Multistep } from '@/components/multistep/Multistep';
import { Step } from '@/components/multistep/Questionnaire';
import { Page } from '@/layouts/Page';
import { CSVProvider } from '@/services/csv/CSVService';

import { Suspense } from 'react';
import { DownloadCatalogue } from './DownloadCatalogue';
import { IssuesStep } from './steps/IssuesStep';
import { ReplacementStep } from './steps/ReplacementStep';
import { ReviewCategoriesStep } from './steps/ReviewCategoriesStep';
import { ReviewManufacturersStep } from './steps/ReviewManufacturersStep';
import { ReviewRegionsStep } from './steps/ReviewRegionsStep';
import { ReviewStep } from './steps/ReviewStep';
import { UpdateStep } from './steps/UpdateStep';
import { UploadStep } from './steps/UploadStep';

export const BulkManage = () => {
  return (
    <Page className="mx-auto flex w-full max-w-6xl flex-col bg-opacity-100 p-12 py-14">
      <div className="border-secondary-std mb-4 border-b pb-4">
        <h1 className="text-4xl font-bold">Bulk manage products</h1>
        <p>Upload a spreadsheet of products to bulk upload them to the system.</p>
      </div>
      <CSVProvider>
        <Multistep>
          <UploadStep />
          <Step
            id="issues"
            title="Issues"
            description="There were some issues with parsing or validating the spreadsheet. Please resolve them and reupload the spreadsheet."
            controls="manual"
          >
            <IssuesStep />
          </Step>
          <Step
            id="manufacturers"
            title="Review manufacturers"
            description="There are manufacturers referenced in the uploaded products that don't exist or can't be automatically found. Please either create or fix the manufacturers below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewManufacturersStep />
            </Suspense>
          </Step>
          <Step
            id="categories"
            title="Review categories"
            description="There are categories referenced in the uploaded products that don't exist or can't be automatically found. Please either create or fix the categories below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewCategoriesStep />
            </Suspense>
          </Step>
          <Step
            id="regions"
            title="Review regions"
            description="There are regions referenced in the uploaded products that don't exist or can't be automatically found. Please either create or fix the categories below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewRegionsStep />
            </Suspense>
          </Step>
          <Step
            id="review"
            title="Review uploads"
            description="Please review the products below and press apply to upload new products."
            controls="manual"
          >
            <ReviewStep />
          </Step>
          <Step
            id="update"
            title="Review updates"
            description="Please review the product updates below and press apply to make changes."
            controls="manual"
          >
            <UpdateStep />
          </Step>
          <Step
            id="replace"
            title="Review replacements"
            description="Please review the replacements below and press finish to apply replacements."
            controls="manual"
          >
            <ReplacementStep />
          </Step>
        </Multistep>
      </CSVProvider>
      <CSVProvider>
        <Multistep>
          <DownloadCatalogue />
        </Multistep>
      </CSVProvider>
    </Page>
  );
};
